import axios from '@api/axios';

const axiosInstance = axios.create({
    baseURL: `/api/patients`
});

const index = function(paginatorOptions = null) {
    return axiosInstance.get('', {
        params: paginatorOptions
    });
};

const create = function(form) {
    return axiosInstance.post('', form);
};

const edit = function(form) {
    return axiosInstance.post(`${form.id}`, form);
};

const get = function(id) {
    return axiosInstance.get(id);
};

const toVue = function(db) {
    let local = {};

    local.id = db.id;
    local.biologicalSex = db.biological_sex;
    local.firstName = db.first_name;
    local.lastName = db.last_name;
    local.identifyAs = db.identify_as;
    local.phoneNumber = db.phone_number;
    local.knownAs = db.go_by_name;
    local.dateOfBirth = db.date_of_birth;
    local.additionalInfo = db.additional_info;
    local.practionerName = db.gp_name;
    local.practionerPractice = db.gp_practice;
    local.practionerEmail = db.gp_email;
    local.practionerPhoneNumber = db.gp_phone_number;

    if(db.address) {
        local.address = {};
        local.address.line1 = db.address.line_1;
        local.address.line2 = db.address.line_2;
        local.address.postalCode = db.address.postal_code;
        local.address.latitude = db.address.latitude;
        local.address.longitude = db.address.longitude;
        local.address.city = db.address.city;
        local.address.county = db.address.county_id;
    }

    return local;
};

export default { axios: axiosInstance, index, create, edit, get, toVue };
